import { Component, inject, Input, OnInit } from '@angular/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
  FunctionOnglet,
} from '../../../../../../manager/edro-network-manager';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { IProduct, IProductFunctionnality } from '../../../../../IProduct';
import {
  LargedTuileComponent,
  TuileButtonProps,
} from '../../../../../../../../components/ecosystems/larged-tuile/larged-tuile.component';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';

@Component({
  selector: 'app-p0003605-card-injection-chlore-controle',
  templateUrl: './p0003605-card-injection-chlore-controle.component.html',
  styleUrls: ['./p0003605-card-injection-chlore-controle.component.scss'],
  standalone: true,
  imports: [LargedTuileComponent, TranslatePipe],
})
export class P0003605CardInjectionChloreControleComponent implements OnInit {
  private edroNetworkManager = inject(EdroNetworkManager);
  private translateService = inject(TranslateService);
  @Input() productClass: IProduct | null = null;
  public actionStack: DeviceActionStackService | null = null;

  public buttons: TuileButtonProps[] = [];
  public buttonMode: TuileButtonProps[] = [];

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );

    this.buttons = [
      {
        title: 'P0003600.card.state.filtration.status.off',
        icon: 'fa-kit fa-picto-off',
        color: 'color-red',
        status: 'inactive',
      },
      {
        title: 'P0003600.card.state.filtration.status.on',
        icon: 'fa-kit fa-picto-on',
        color: 'color-green',
        status: 'active',
      },
    ];

    this.buttonMode = [
      {
        title: 'P0003605.dashboard.off',
        icon: 'fa-kit fa-picto-off',
        color: 'color-red',
      },
      {
        title: 'P0003605.dashboard.regulation',
        icon: 'fa-kit fa-picto-programme',
        color: 'color-orange',
      },
      {
        title: 'P0003605.dashboard.hivernage',
        icon: 'fa-kit fa-picto-hiver',
        color: 'color-orange',
      },
    ];
  }

  async openProductModal() {
    await this.edroNetworkManager.openProductModal(
      this.productClass!,
      IProductFunctionnality.INJECTION_CHLORE,
      FunctionOnglet.PARAMETRE_REGLAGE,
      this.translateService.instant('P0003605.dashboard.injectionCL'),
    );
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
}
